import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Button, Dialog, Form, Input, Loading } from 'tdesign-react';
import Descriptions from '@/components/Descriptions';
import NoData from '@/components/NoData';
import { fetchKeyHashRangeMatch, resetKeyHash } from '@/slices/topicSlice';
import { isVoid } from '@/utils/common';

const { FormItem } = Form;

function ModalKeyMatch({
  visible,
  handleClose,
  params,
  fetchKeyHashRangeMatch,
  detail,
  loading,
  resetKeyHash,
}) {
  const [key, setKey] = useState();
  const [form] = Form.useForm();

  useEffect(() => {
    if (!visible) {
      form.reset();
      setKey(null);
      resetKeyHash();
    }
  }, [visible, form, resetKeyHash]);

  const handleSearch = ({ validateResult, fields }) => {
    if (validateResult === true) {
      fetchKeyHashRangeMatch({
        ...params,
        key: fields.key,
      });
      setKey(fields.key);
    }
  };

  const body = useMemo(() => {
    if (isVoid(key)) {
      return (
        <NoData
          tip='请在上方输入key值查询'
          imgStyle={{ width: 120, height: 120, marginBottom: -20, marginTop: 46 }}
        />
      );
    }

    return (
      <Loading loading={loading} size='small'>
        <Descriptions title='基础信息' column={2}>
          <Descriptions.Item label='key' value={key} />
          <Descriptions.Item label='Hash值' value={detail?.slot} />
          <Descriptions.Item label='Topic' span={2} value={detail?.topic} />
        </Descriptions>

        {detail && detail.match ? (
          <Descriptions style={{ marginTop: 10 }} column={1} title='归属消费者'>
            <Descriptions.Item label='消费名称' value={detail.consumerName} />
            <Descriptions.Item label='消费地址' value={detail.address} />
            <Descriptions.Item label='匹配HashRange' value={detail.hashRange} />
          </Descriptions>
        ) : (
          <Descriptions style={{ marginTop: 10 }} title='归属消费者'>
            <EmptyContent>暂无内容</EmptyContent>
          </Descriptions>
        )}
      </Loading>
    );
  }, [key, detail, loading]);

  return (
    <Dialog
      visible={visible}
      header='查看key归属'
      destroyOnClose
      footer={null}
      onClose={handleClose}
    >
      <Form form={form} layout='inline' onSubmit={handleSearch} style={{ marginBottom: 20 }}>
        <SearchBar>
          <FormItem style={{ flex: 1, marginRight: 8 }} name='key' rules={[{ required: true }]}>
            <Input clearable />
          </FormItem>
          <Button loading={loading} type='submit'>
            搜索
          </Button>
        </SearchBar>
      </Form>
      <Container>{body}</Container>
    </Dialog>
  );
}

export default connect(
  (state) => ({
    loading: state.topic.keyHashSearching,
    detail: state.topic.keyHash,
  }),
  {
    fetchKeyHashRangeMatch,
    resetKeyHash,
  },
)(ModalKeyMatch);

const SearchBar = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const Container = styled.div`
  border-radius: 6px;
  border: 1px solid var(--grey-line, rgba(0, 0, 0, 0.05));
  background: #fafafa;
  min-height: 244px;
  padding: 20px;
  box-sizing: border-box;
`;

const EmptyContent = styled.div`
  color: var(--td-text-color-secondary);
  font-size: 14px;
  text-align: center;
  width: 100%;
`;
